import { FormActivity, FormActivityModel } from './form-activity';

export class ContinuousActivityModel extends FormActivityModel {
  constructor(options?: Partial<ContinuousActivityModel>) {
    super(options);
  }
}

export class ContinuousActivity extends FormActivity<ContinuousActivityModel> {
  constructor(options?: Partial<ContinuousActivity>) {
    super(options);

    this.type = 'continuous-activity';
    this.description = 'An activity that stays In Progress once started.';
    this.name = 'Continuous';

    this.model = new ContinuousActivityModel(options ? options.model : null);

    this.model.screenName = this.model.screenName || 'Continuous Activity';
  }
}